export const enum Testkits {
  enzyme = 'enzyme',
  vanilla = 'vanilla',
  puppeteer = 'puppeteer',
}

export const enum TestTypes {
  testkitExists,
  testkitExports,
}
